'use client';

export default function HideFooterMap() {
  return (
    <style jsx global>{`
      .footer-map-container {
        display: none;
      }
      .footer-map-img {
        display: block;
      }
      @media (min-width: 1280px) {
        .footer-map-container {
          display: block;
        }
      }
    `}</style>
  );
}
